export default "__VITE_ASSET__$JdR2re7WHPfcroInHOXqg__"